// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "staticPC/js/" + chunkId + "." + {"16":"3a81cf7d","189":"bf997441","222":"6f0b820d","319":"0d4d1373","327":"5a2bb690","336":"07e8931d","464":"32bbc6fc","506":"863e6172","606":"e49e3d73"}[chunkId] + ".js";
};